var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled, { css } from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import DoneIconBase from '@material-ui/icons/Done';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { colorWhiteSelector, getColorErrorSelector, getColorGreySelector, getColorSuccessSelector, getColorWarnSelector, getSpacingSelector } from '@signal/theme/selectors';
import Typography from '../Typography';
import { TOASTR_SEVERITY_ERROR, TOASTR_SEVERITY_SUCCESS, TOASTR_SEVERITY_SUCCESS_PERSISTENT, TOASTR_SEVERITY_WARNING } from './constants';
export var Wrapper = styled(function (_ref) {
  var open = _ref.open,
      severity = _ref.severity,
      rest = _objectWithoutProperties(_ref, ["open", "severity"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  padding:\n   ", "px\n    ", "px\n     ", "px\n      ", "px;\n\n  border-radius: 6px;\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), getSpacingSelector(), getSpacingSelector(2), getSpacingSelector(), getSpacingSelector(2), function (props // box shadow doesn't fade on dismiss, hide instead
) {
  return props.open ? "box-shadow:\n       ".concat(getSpacingSelector(0.5)(props), "px\n        ").concat(getSpacingSelector(0.5)(props), "px\n         ").concat(getSpacingSelector()(props), "px\n          ").concat(getColorGreySelector()(props), ";") : '';
}, function (props // colorize severity states
) {
  return props.severity === TOASTR_SEVERITY_ERROR ? "background: ".concat(getColorErrorSelector()(props)) : '';
}, function (props) {
  return props.severity === TOASTR_SEVERITY_SUCCESS ? "background: ".concat(getColorSuccessSelector()(props)) : '';
}, function (props) {
  return props.severity === TOASTR_SEVERITY_SUCCESS_PERSISTENT ? "background: ".concat(getColorSuccessSelector()(props)) : '';
}, function (props) {
  return props.severity === TOASTR_SEVERITY_WARNING ? "background: ".concat(getColorWarnSelector()(props)) : '';
});
var whiteIconCss = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), colorWhiteSelector);
export var CloseIconWhite = styled(CloseIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), whiteIconCss);
export var DoneIcon = styled(DoneIconBase)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), whiteIconCss);
export var ErrorIconWhite = styled(ErrorIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), whiteIconCss);
export var ToastrTypography = styled(Typography).attrs(function () {
  return {
    variant: 'body1'
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-left: ", "px;\n  margin-right: ", "px;\n"])), getSpacingSelector(2), getSpacingSelector(2));